module.exports = __webpack_public_path__ + "static/media/TTFeature1.400f2881.avif";